export default "__VITE_ASSET__Hho1pUOU__"